export const contactInfo = {
  companyName: "High Hair Room",
  companyOfficialName: "High Hair Room Oy",
  phoneNumber: "+358105822861",
  whatsAppNumber: "+358505598055",
  email: "highhairroom@gmail.com",
  YTunnus: "3318990-3",
  street: "Korppaanmäentie 12 Liiketila 1",
  postalCode: "00300",
  city: "Helsinki",
  country: "Finland",
  instagram: "high_hair_room",
};
